import { API_BASE_PATH } from '@/constants/routeConstants'
import { fetchWithAuth } from '@/utils/fetch'

/**
 * Creates a complete API URL with the base path
 */
export const createApiUrl = (...segments: string[]): string => {
  return `${API_BASE_PATH}/${segments.join('/')}`
}

/**
 * Creates an organization-specific API URL
 */
export const createOrgApiUrl = (
  orgId: string,
  ...segments: string[]
): string => {
  return createApiUrl('organizations', orgId, ...segments)
}

/**
 * Standard GET request
 */
export const apiGet = async <T>(
  url: string,
  options?: RequestInit & { timeout?: number },
): Promise<T> => {
  return fetchWithAuth<T>(url, options)
}

/**
 * Standard POST request with JSON body
 */
export const apiPost = async <T>(
  url: string,
  data?: Record<string, unknown>,
  options?: RequestInit & { timeout?: number },
): Promise<T> => {
  // Create new headers object combining user headers with required ones
  const headers = new Headers(options?.headers || {})
  headers.set('Content-Type', 'application/json')

  return fetchWithAuth<T>(url, {
    method: 'POST',
    ...options,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  })
}

/**
 * Standard PUT request with JSON body
 */
export const apiPut = async <T>(
  url: string,
  data?: Record<string, unknown>,
  options?: RequestInit & { timeout?: number },
): Promise<T> => {
  // Create new headers object combining user headers with required ones
  const headers = new Headers(options?.headers || {})
  headers.set('Content-Type', 'application/json')

  return fetchWithAuth<T>(url, {
    method: 'PUT',
    ...options,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  })
}

/**
 * Standard DELETE request
 */
export const apiDelete = async <T>(
  url: string,
  options?: RequestInit & { timeout?: number },
): Promise<T> => {
  return fetchWithAuth<T>(url, {
    method: 'DELETE',
    ...options,
  })
}
